export default {
    props: {
        popuptitle: String,
        classname: String
    },
    template: `
    <transition name="fade" appear>
        <div class="popup-wrap" @click.self="closePopup">
          <div class="popup" :class="classname">
            <button @click="closePopup" class="close-popup"></button>
            <h5>{{popuptitle}}</h5>
            <div class="popup-content">
               <slot></slot>
            </div>
          <div>
        </div>
    </transition>`,
    data() {
        return {}
    },
    methods: {
        closePopup() {
            this.$emit('closepopup')
        }
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/vueComponent/ui/popup.js